<template>
    <div class="RiskMannEditorTexto">
        <vue-editor :class="{ 'border border-danger': estado === 'Error' && !contenidoTemp }" v-model="contenidoTemp"
            :editor-toolbar="customToolbar" :editorOptions="editorSettings" />
    </div>
</template>

<script>
import { VueEditor, Quill } from "vue2-editor";
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-vue';
const fonts = Quill.import('formats/font');
const Size = Quill.import('attributors/style/size');
const fontList = ['Arial', 'Courier', 'Garamond', 'Tahoma', 'Times New Roman', 'Verdana'];
const fontSizeArr = ['10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
let fontStyles = "";
const fontNames = fontList.map(font => getFontName(font));
Size.whitelist = fontSizeArr;
fonts.whitelist = fontNames;
function getFontName(font) {
    return font.toLowerCase().replace(/\s/g, "-");
}
fontList.forEach((font) => {
    let fontName = getFontName(font);
    fontStyles += ".ql-snow .ql-picker.ql-font .ql-picker-label[data-value=" + fontName + "]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=" + fontName + "]::before {" +
        "content: '" + font + "';" +
        "font-family: '" + font + "', sans-serif;" +
        "}" +
        ".ql-font-" + fontName + "{" +
        " font-family: '" + font + "', sans-serif;" +
        "}";
});
const node = document.createElement('style');
node.innerHTML = fontStyles;
document.body.appendChild(node);
Quill.register(Size, true);
Quill.register(fonts, true);
Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageResize', ImageResize);
export default {
    name: "IperEditorTexto",

    props: {
        contenido: String,
        estado: String
    },

    components: {
        VueEditor
    },

    data() {
        return {
            contenidoTemp: JSON.parse(JSON.stringify(this.contenido)),
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                [{ 'font': fonts.whitelist }],
                [{ 'size': fontSizeArr }],
                ["bold", "italic", "underline", "strike"],
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                ["blockquote"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ indent: "-1" }, { indent: "+1" }],
                [{ color: [] }, { background: [] }],
                ["link", "image", "video"],
            ],
            editorSettings: {
                modules: {
                    imageDrop: true,
                    imageResize: {},
                },
                clipboard: {
                    matchVisual: false
                }
            },
        }
    },

    watch: {
        contenido() {
            this.contenidoTemp = JSON.parse(JSON.stringify(this.contenido))
        },

        contenidoTemp() {
            this.$emit("contenido", this.contenidoTemp);
        }
    },

    mounted() {
        this.agregarTextoAyuda();
    },

    methods: {
        agregarTextoAyuda() {
            /* eslint-disable */
            $('.ql-font').attr('data-toggle', 'tooltip');
            $('.ql-font').attr('data-placement', 'bottom');
            $('.ql-font').attr('title', 'Fuente');

            $('.ql-header').attr('data-toggle', 'tooltip');
            $('.ql-header').attr('data-placement', 'bottom');
            $('.ql-header').attr('title', 'Tipo de Fuente');

            $('.ql-size').attr('data-toggle', 'tooltip');
            $('.ql-size').attr('data-placement', 'bottom');
            $('.ql-size').attr('title', 'Tamaño de Fuente');

            $('.ql-bold').attr('data-toggle', 'tooltip');
            $('.ql-bold').attr('data-placement', 'bottom');
            $('.ql-bold').attr('title', 'Negrita (Ctrl + B)');

            $('.ql-italic').attr('data-toggle', 'tooltip');
            $('.ql-italic').attr('data-placement', 'bottom');
            $('.ql-italic').attr('title', 'Cursiva (Ctrl + I)');

            $('.ql-underline').attr('data-toggle', 'tooltip');
            $('.ql-underline').attr('data-placement', 'bottom');
            $('.ql-underline').attr('title', 'Subrayar (Ctrl + U)');

            $('.ql-strike').attr('data-toggle', 'tooltip');
            $('.ql-strike').attr('data-placement', 'bottom');
            $('.ql-strike').attr('title', 'Tachado');

            $('.ql-align[value=""]').attr('data-toggle', 'tooltip');
            $('.ql-align[value=""]').attr('data-placement', 'bottom');
            $('.ql-align[value=""]').attr('title', 'Alinear a la Izquierda');

            $('.ql-align[value="center"]').attr('data-toggle', 'tooltip');
            $('.ql-align[value="center"]').attr('data-placement', 'bottom');
            $('.ql-align[value="center"]').attr('title', 'Centrar');

            $('.ql-align[value="right"]').attr('data-toggle', 'tooltip');
            $('.ql-align[value="right"]').attr('data-placement', 'bottom');
            $('.ql-align[value="right"]').attr('title', 'Alinear a la Derecha');

            $('.ql-align[value="justify"]').attr('data-toggle', 'tooltip');
            $('.ql-align[value="justify"]').attr('data-placement', 'bottom');
            $('.ql-align[value="justify"]').attr('title', 'Justificar');

            $('.ql-blockquote').attr('data-toggle', 'tooltip');
            $('.ql-blockquote').attr('data-placement', 'bottom');
            $('.ql-blockquote').attr('title', 'Cita');

            $('.ql-list[value="ordered"]').attr('data-toggle', 'tooltip');
            $('.ql-list[value="ordered"]').attr('data-placement', 'bottom');
            $('.ql-list[value="ordered"]').attr('title', 'Numeración');

            $('.ql-list[value="bullet"]').attr('data-toggle', 'tooltip');
            $('.ql-list[value="bullet"]').attr('data-placement', 'bottom');
            $('.ql-list[value="bullet"]').attr('title', 'Viñeta');

            $('.ql-indent[value="-1"]').attr('data-toggle', 'tooltip');
            $('.ql-indent[value="-1"]').attr('data-placement', 'bottom');
            $('.ql-indent[value="-1"]').attr('title', 'Disminuir Sangría');

            $('.ql-indent[value="+1"]').attr('data-toggle', 'tooltip');
            $('.ql-indent[value="+1"]').attr('data-placement', 'bottom');
            $('.ql-indent[value="+1"]').attr('title', 'Aumentar Sangría');

            $('.ql-color').attr('data-toggle', 'tooltip');
            $('.ql-color').attr('data-placement', 'bottom');
            $('.ql-color').attr('title', 'Color de Fuente');

            $('.ql-background').attr('data-toggle', 'tooltip');
            $('.ql-background').attr('data-placement', 'bottom');
            $('.ql-background').attr('title', 'Color de Resaltado');

            $('.ql-link').attr('data-toggle', 'tooltip');
            $('.ql-link').attr('data-placement', 'bottom');
            $('.ql-link').attr('title', 'Insertar Enlace');

            $('.ql-image').attr('data-toggle', 'tooltip');
            $('.ql-image').attr('data-placement', 'bottom');
            $('.ql-image').attr('title', 'Insertar Imagen');

            $('.ql-video').attr('data-toggle', 'tooltip');
            $('.ql-video').attr('data-placement', 'bottom');
            $('.ql-video').attr('title', 'Insertar Video');
        },
    }
}
</script>

<style src="@/../public/css/components/vue2-editor.css" />
<style scoped></style>